import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/shipment-plan/manage.php`,
  API_SEARCH: `/ERP/shipment-plan/search.php`,
  API_FCL: `/ERP/shipment-plan/fcl-estimate.php`,
};

/* แผนโหลดสินค้า / การจองเรือ */
const ShipmentPlanService = () => {
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const deleted = (id) => api.delete(`${API_URL.API_MANAGE}?id=${id}`);
  const get = (id) => api.get(`${API_URL.API_MANAGE}?code=${id}`);
  const search = (parm = {}, config = {}) =>
    api.post(`${API_URL.API_SEARCH}`, parm, { ...config, cancle: true });

  /* คำนวณจำนวนตู้จากมาตรฐานกล่องต่อตู้ของสินค้าในแต่ละ Job */
  const estimateFcl = (jocodes = []) =>
    api.post(`${API_URL.API_FCL}`, { jocodes });

  return { create, update, deleted, get, search, estimateFcl };
};

export default ShipmentPlanService;
